import styles from './CmsIconHeadline.module.scss';
import {
  FontAwesomeProIcon,
  Heading,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';
import React from 'react';
import classNames from 'classnames';

const CmsIconHeadline = ({ headingLevel = 2, headline, icon, colorTheme }) => (
  <div className={styles.container}>
    <FontAwesomeProIcon
      className={classNames(styles[colorTheme], styles.icon)}
      icon={icon}
      role="presentation"
      type="regular"
    />
    <Heading
      as={getHeadingTag(headingLevel)}
      className={classNames(styles[colorTheme], styles.headline)}
      size="h1"
    >
      {headline}
    </Heading>
  </div>
);

export default CmsIconHeadline;
